import Observer from '~/utils/lib/core/observer'

/**
 * @constant {string}
 * @default
 */
export const STORE_PREFIX = 'buzz'

/** @constant {string} */
export const baseURL = import.meta.env.VITE_BUZZ_WS_DOMAIN_URL || ''

/** @constant {string} */
export const basePath = import.meta.env.VITE_BUZZ_WS_PATH_URL || ''

/**
 * @constant {object}
 * @desc Instance internal events
 */
export const EVENTS = {
  ON_SOCKET_OPEN: 'buzz/onSocketOpen',
  ON_SOCKET_CLOSE: 'buzz/onSocketClose',
  ON_SOCKET_ERROR: 'buzz/onSocketError',
  ON_SOCKET_STATUS_CHANGE: 'buzz/onSocketStatusChange',
  ON_MESSAGE: 'buzz/onMessage',
}

/**
 * @constant {object}
 * @desc Remote sample events
 * @readonly
 */
export const REMOTE_EVENTS = {
  PRESENCE: 'presence',
  MESSAGE: 'message',
}

/** @constant */
export const SOCKET_STATUS = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  OPEN: 'open',
  RECONNECTING: 'reconnecting',
  CLOSED: 'closed',
}

/** @constant */
export const ERRORS = {
  MISSING_SOCKET_URL: 'missing websocket URL',
  SOCKET_NOT_OPEN: 'websocket is not open',
  UNKNOWN_MESSAGE_SCHEMA: 'unknown websocket message schema',
}

/**
 * @constant {object}
 * @readonly
 */
export const MICRO_SERVICE_ERRORS = /** @type {const} */ ({
  MISC: 'miscelleanous micro service error returned',
})

/** @type {Observer} */
export const observer = new Observer()

